import { inject, Pipe, PipeTransform } from '@angular/core';
import { USER } from '@marmon/frontend/common';
import { accessTag, AlgoliaAnalysis } from '@marmon/shared/types/analysis';

@Pipe({
	standalone: true,
	name: 'isOwnerAnalysis',
})
export class IsOwnerAnalysisPipe implements PipeTransform {
	private readonly user = inject(USER);

	transform(analysis: AlgoliaAnalysis) {
		const user = this.user.value;
		if (!user) return false;
		return analysis.createdById === user.id;
	}
}
